import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, MoveRight } from "lucide-react";
import PageHeader from "@/components/admin/PageHeader";

export default function SettingsChatInterface() {
    const navigate = useNavigate();

    return (
        <div className="p-10 max-w-4xl">
            <PageHeader eyebrow="Settings" title="Chat Interface" testid="page-settings-chat-interface" />

            <div className="bg-white border border-stone-200 rounded-xl p-12 text-center" data-testid="chat-interface-moved">
                <div className="w-14 h-14 rounded-xl bg-orchid-700/10 text-orchid-700 mx-auto flex items-center justify-center mb-5">
                    <MoveRight size={24} />
                </div>
                <h2 className="font-heading text-2xl text-orchid-700 mb-2">Page moved</h2>
                <p className="text-sm text-stone-600 max-w-md mx-auto mb-1">
                    Chat interface settings have moved to the <strong>Deploy</strong> section, under <strong>Chat widget</strong>, to keep all deployment options in one place.
                </p>
                <div className="inline-flex items-center gap-2 text-xs text-stone-500 mb-6">
                    Deploy <ArrowRight size={11} /> Chat widget
                </div>
                <div>
                    <button
                        onClick={() => navigate("/deploy")}
                        data-testid="go-to-deploy"
                        className="inline-flex items-center gap-2 bg-orchid-700 hover:bg-orchid-600 text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors"
                    >
                        Go to Chat widget settings <ArrowRight size={14} />
                    </button>
                </div>
                <p className="text-xs text-stone-500 mt-6">All your customisation — colours, greeting, position — is available in the new location.</p>
            </div>
        </div>
    );
}
